import { render, staticRenderFns } from "./NewsAtlas.vue?vue&type=template&id=c6d28a52"
import script from "./NewsAtlas.vue?vue&type=script&lang=js"
export * from "./NewsAtlas.vue?vue&type=script&lang=js"
import style0 from "./NewsAtlas.vue?vue&type=style&index=0&id=c6d28a52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports